import { AssetTemplateSubCategoryType, TransactionItemType } from "@/enums/enums";
import { GetTimezoneOffset, MerchantId, SetHeaderService } from "@/helper/userHelper";
import { i18n } from "@/i18n";
import { AssetTemplateModel, AssetUnitModel } from "@/model/asset/assetModel";
import service from "../baseHttpService";
/* eslint @typescript-eslint/no-var-requires: "off" */
const qs = require("qs");
class AssetService {
  GetAssetTemplateTable(searchCriteria: any) {
    const _input = {
      merchantId: MerchantId(),
      searchCriteria: searchCriteria,
      language: i18n.locale,
    };
    return service.peakExportAPI.post("/api/Table/GetAssetTemplateTable", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  GetAssetUnitTable(input: any) {
    const _input = {
      merchantId: MerchantId(),
      unitType: TransactionItemType.Asset,
      isDeleted: false,
      isUseMainDatabase: input.isUseMainDatabase,
      pageNo: input.pageNo,
      pageSize: input.pageSize,
    };
    return service.peakExportAPI.post("/api/Product/GetUnitTable", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  GetAssetTable(searchCriteria: any) {
    const _input = {
      merchantId: MerchantId(),
      searchCriteria: searchCriteria,
      language: i18n.locale,
    };
    return service.peakExportAPI.post("/api/Table/GetAssetTable", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  GetAssetDepreciationTable(searchCriteria: any) {
    const _input = {
      merchantId: MerchantId(),
      searchCriteria: searchCriteria,
      language: i18n.locale,
    };
    return service.peakExportAPI
      .post("/api/Table/GetAssetDepreciationTable", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  GetAssetDetail(assetId: number) {
    const _input = {
      merchantId: MerchantId(),
      assetId: assetId,
    };
    return service.peakRealTimeAPI.post("/api/Asset/GetAssetDetail", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  GetAssetTemplateDetail(assetTemplateId: number) {
    const _input = {
      merchantId: MerchantId(),
      assetTemplateId: assetTemplateId,
    };
    return service.peakRealTimeAPI.post("/api/Asset/GetAssetTemplateDetail", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  CreateAssetTemplate(assetTemplateList: Array<AssetTemplateModel>) {
    const _input = {
      merchantId: MerchantId(),
      assetTemplateList: assetTemplateList,
    };
    return service.peakRealTimeAPI.post("/api/Asset/InsertAssetTemplate", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  CreateAssetUnit(assetUnit: AssetUnitModel) {
    const _input = {
      merchantId: MerchantId(),
      unit: assetUnit,
    };
    return service.peakRealTimeAPI.post("/api/Product/CreateUnitOnce", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DeleteUnit(assetUnit: any) {
    const _input = {
      merchantId: MerchantId(),
      unit: assetUnit,
      isDeleted: true,
    };
    return service.peakRealTimeAPI.post("/api/Product/DeleteUnit", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  ValidateDeleteUnit(assetUnitId: number) {
    const _input = {
      merchantId: MerchantId(),
      unitId: assetUnitId,
    };
    return service.peakRealTimeAPI.post("/api/Asset/ValidateDeleteUnit", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  EditUnit(assetUnit: any) {
    const _input = {
      merchantId: MerchantId(),
      unit: assetUnit,
    };
    return service.peakRealTimeAPI.post("/api/Product/EditUnit", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  UpdateAssetTemplate(assetTemplate: AssetTemplateModel) {
    const _input = {
      merchantId: MerchantId(),
      assetTemplate: assetTemplate,
    };
    return service.peakRealTimeAPI.post("/api/Asset/UpdateAssetTemplate", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  GetSuggestionAssetTemplateCode(assetTemplateSubCategoryType: AssetTemplateSubCategoryType) {
    const _input = {
      merchantId: MerchantId(),
      assetTemplateSubCategoryType: assetTemplateSubCategoryType,
    };
    return service.peakRealTimeAPI
      .post("/api/Asset/GetSuggestionAssetTemplateCode", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  GetSuggestionAssetUnitCode() {
    const _input = {
      merchantId: MerchantId(),
    };
    return service.peakRealTimeAPI
      .post("/api/Asset/GetSuggestionAssetUnitCode", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoExportAssetGroup(input: any) {
    const _input = {
      merchantId: MerchantId(),
      timezoneOffset: GetTimezoneOffset(),
      isSendEmail: input.isSendEmail,
      receiveEmailList: input.receiveEmailList,
      fromDate: input.fromDate,
      toDate: input.toDate,
      orderText: input.orderText,
      searchText: input.searchText,
      isGroup: input.isGroup,
      assetCategoryType: input.assetCategoryType,
      assetSubCategoryType: input.assetSubCategoryType,
      language: i18n.locale,
      fromEmail: input.fromEmail,
      isShowAccount: input.isShowAccount,
      isShowAmountRecordInSystem: input.isShowAmountRecordInSystem,
    };
    return service.peakReportAPI.post("/api/EmailReport/ExportFixedAsset", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoExportAsset(input: any) {
    const _input = {
      merchantId: MerchantId(),
      timezoneOffset: GetTimezoneOffset(),
      isSendEmail: input.isSendEmail,
      receiveEmailList: input.receiveEmailList,
      fromDate: input.fromDate,
      toDate: input.toDate,
      orderText: input.orderText,
      searchText: input.searchText,
      assetTemplateId: input.assetTemplateId,
      fromEmail: input.fromEmail,
      isShowAccount: input.isShowAccount,
      isShowAmountRecordInSystem: input.isShowAmountRecordInSystem,
    };
    return service.peakReportAPI.post("/api/EmailReport/ExportAsset", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoStopAssetDepreciation(input: any) {
    const _input = {
      merchantId: MerchantId(),
      assetStopDepreciation: {
        assetId: input.assetId,
        stopAssetDepreciationDate: input.stopAssetDepreciationDate,
      },
    };
    return service.peakRealTimeAPI.post("/api/Asset/StopAssetDepreciation", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetAssetTemplateValidateIsCanVoid(assetTemplateIdList: any) {
    const _input = {
      merchantId: MerchantId(),
      assetTemplateIdList: assetTemplateIdList,
    };
    return service.peakRealTimeAPI
      .post("/api/Asset/GetAssetTemplateValidateIsCanVoid", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoVoidAssetTemplate(assetTemplateIdList: any) {
    const _input = {
      merchantId: MerchantId(),
      assetTemplateIdList: assetTemplateIdList,
    };
    return service.peakRealTimeAPI.post("/api/Asset/VoidAssetTemplate", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoVoidAsset(assetIdList: any) {
    const _input = {
      merchantId: MerchantId(),
      assetIdList: assetIdList,
    };
    return service.peakRealTimeAPI.post("/api/Asset/VoidAsset", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoInsertAssetCarryBalance(assetList: any) {
    const _input = {
      merchantId: MerchantId(),
      assetList: assetList,
      language: i18n.locale,
    };
    return service.peakRealTimeAPI
      .post("/api/Asset/InsertAssetCarryBalance", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetAssetTemplateByCode(assetTemplateCodeList: any) {
    const _input = {
      merchantId: MerchantId(),
      assetTemplateCodeList: assetTemplateCodeList,
      isUseMainDatabase: false,
    };
    return service.peakExportAPI.post("/api/Asset/GetAssetTemplateByCode", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetAutoCompleteAssetTemplate(input: any) {
    const _input = {
      merchantId: MerchantId(),
      searchText: input.searchText,
      assetCategoryId: input.assetCategoryId,
      assetSubCategoryId: input.assetSubCategoryId,
    };
    return service.peakRealTimeAPI
      .post("/api/Asset/GetAutoCompleteAssetTemplate", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetAssetTemplateCategoryMenu() {
    const _input = {
      merchantId: MerchantId(),
    };
    return service.peakExportAPI
      .post("/api/Asset/GetAssetTemplateCategoryMenu", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  GetAssetTemplateCount() {
    const _input = {
      merchantId: MerchantId(),
    };
    return service.peakExportAPI.post("/api/Table/GetAssetTemplateCount", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoUpdateAssetCarryBalance(asset: any) {
    const _input = {
      data: {
        asset: asset,
      },
    };
    return service.peakRealTimeAPI.post("/api/Asset/UpdateAsset", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetAssetTemplateCodeByAssetTemplateIdList(assetTemplateIdList: Array<number>) {
    const _input = {
      assetTemplateIdList: assetTemplateIdList,
    };
    return service.peakExportAPI
      .post("/api/Asset/GetAssetTemplateCodeByAssetTemplateIdList", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
}
export default new AssetService();
